import AnswerValidity from "@/components/AnswerValidity";
import AnswerValidityChren from "@/components/AnswerValidityChren";
import AnswerValidityChrenClick from "@/components/AnswerValidityChrenClick";
import CarouselComponent from "@/components/CarouselComponent";
import { contexData } from "@/store";
import { Checkbox, Input, Radio } from "antd";
import classNames from "classnames";
import { cloneDeep, get, isEmpty, isObject } from "lodash";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { InputWapper } from "../../utils/helper";
import ModuleDom from "./js/module";
import styles from "./matrix.module.less";
import { language } from "@/utils/language";
const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
//矩阵题表头设置
const TitleRow = ({
  rowData,
  firstStyle,
  leaveStyle,
  direction,
  fadeOut,
  questionNum,
  optionForm,
}) => {
  let options = [];
  if (direction) {
    options = rowData.filter((item) => {
      return item.hide !== 1;
    });
  } else {
    options = rowData.filter((item) => {
      return item.hide !== 1;
    });
  }
  const { infoContex } = useContext(contexData);
  return (
    <li className={styles.titleRow}>
      {/**第一列横竖是要空出来的，所以在表头加入第一位 */}
      {[<div key="-1" style={firstStyle} />].concat(
        options.map(({ description, id, moduleOption }, index) => {
          if (fadeOut && index >= questionNum && optionForm !== 4) {
            return null;
          }
          leaveStyle = {
            ...leaveStyle,
            flexDirection: "column",
            color: infoContex.preferences?.optionColour,
          };
          // 只有当不是module隐藏的选项的时候才显示，否则隐藏不显示
          if (+moduleOption !== 2) {
            return (
              <AnswerValidity
                direction={direction}
                info={{ id: id }}
                key={index}
                className={classNames({
                  disabled: +moduleOption !== 0,
                })}
                dangerouslySetInnerHTML={{
                  __html: description
                    .replace(/<p><\/p>/g, "<br />")
                    .replace(/\n\n/g, "<br />")
                    .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                }}
                style={leaveStyle}
              />
            );
          }
          return null;
        })
      )}
    </li>
  );
};

let dataTotal = {};

const Matrix = ({ info, answer, changeAnswer }) => {
  // 默认有选中项的逻辑，通过循环获取到已经选择的项 格式{"id": {"optionsId": null 或者 内容}}
  console.log(`src\\pages\\matrix\\matrix.js`);
  const [questionNum, setQuestionNum] = useState(1);
  const [carouseFn, setcarouseFn] = useState(null);
  const { dispatch } = useContext(contexData); //解构得到属性
  const [opneIdInfo, setOpneIdInfo] = useState({})
  useEffect(() => {
    const childs = get(info, "childs", []);
    const newAnswer = {};
    for (let i = 0; i < childs.length; i++) {
      const childId = childs[i].id;
      // 找出已选择的项
      const selecteOptions = get(childs[i], "options", [])
        .filter((item) => +item.selected === 1)
        .map((item) => item.id);
      // 通过reduce方法生成{"option": null, ..., "option": null}
      const selectAnswer = selecteOptions.reduce((pre, current, index) => {
        return { ...pre, [current]: null };
      }, {});
      if (!isEmpty(selectAnswer)) {
        newAnswer[childId] = selectAnswer;
      }
    }
    if (!isEmpty(newAnswer)) {
      //后面是受控组件，所以要调用方法存储已经选择的答案
      changeAnswer(newAnswer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!answer[info.id] && Object.keys(answer).length) {
      changeAnswer(answer);
    }
  }, [answer]);


  // type值可能为 radio checkbox input
  // options是每道题对应的选项 注意不是实际选项，实际选项中每道题optionId是不一样的，在childs里面
  // 此到答题问题id，用于取值的时候使用，因为可能存在多道题在组成一道答题
  // childs 实际的每道题 对应的每道题的选项都在单个child的options里面
  // preferences 一些额外属性
  let { type, options, id, childs, preferences } = info;

  // firstColumnWidth 首页的宽度
  // direction Q/A A/Q
  // headLineShow 每个几行显示一个表头
  let {
    firstColumnWidth,
    direction,
    fadeOut,
    headLineShow,
    optionForm,
    pcH5Setting,
    limit,
  } = get(preferences, "childPrefer", {
    firstColumnWidth: 0,
    direction: 0,
    headLineShow: 0,
  });
  headLineShow = +headLineShow;
  const { infoContex } = useContext(contexData);
  // 算出第一列宽度
  const firstStyle = {
    width: (firstColumnWidth || 15) + "%",
    flexDirection: "column",
    color: infoContex.preferences?.sonColour,
  };

  const leaveStyle = {
    width:
      (
        (100 - firstColumnWidth) /
        (+direction === 0 ? options : childs).filter(
          (item) => +item.hide === 0 && item.moduleOption !== 2
        ).length
      ).toFixed(2) + "%",
  };

  if (fadeOut == 1 && direction) {
    leaveStyle.width =
      ((100 - firstColumnWidth) / questionNum).toFixed(2) + "%";
  }

  // 设置 行和列 头的信息 根据 direction属性 改变
  let rowData = options,
    colData = childs;
  if (colData.length === 0) {
    console.error("数据有误联系管理员  childs [] matrix");
  }

  // 行列单选添加标记
  if (limit) {
    colData.map((question) => {
      (question.options || []).map((option, index) => {
        option.sameLine = colData
          .filter((in_qustion) => in_qustion.id !== question.id)
          .map((in_qustion) => in_qustion?.options?.[index]?.id);
      });
    });
  }

  if (+direction === 1) {
    if (colData.length === 0) {
      // childs[0].options
      console.error("数据有误联系管理员");
      colData.childs = [{ options: [] }];
    } else {
      [rowData, colData] = [colData, options];
    }

    const chidsOptions = (item) => {
      let _options = [];

      rowData.forEach((item2) => {
        const _item2 = cloneDeep(item2);
        _options.push(
          ..._item2.options.filter((item3) => {
            item3.options_3 = item2;
            return item3.codeValue === item.codeValue;
          })
        );
      });
      return _options;
    };
    colData = colData
      .filter((item) => {
        return item.moduleOption !== 2;
      })
      .map((item) => {
        return {
          ...item,
          options_1: chidsOptions(item),
        };
      });
  }
  const titleRowProps = { firstStyle, leaveStyle, rowData, colData, direction, optionForm };
  const deepMerge = (obj1, obj2) => {
    let key;
    for (key in obj2) {
      // 如果target(也就是obj1[key])存在，且是对象的话再去调用deepMerge，否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
      // 如果obj2[key]没有值或者值不是对象，此时直接替换obj1[key]
      obj1[key] =
        obj1[key] &&
          obj1[key].toString() === "[object Object]" &&
          obj2[key] &&
          obj2[key].toString() === "[object Object]"
          ? deepMerge(obj1[key], obj2[key])
          : (obj1[key] = obj2[key]);
    }
    return obj1;
  };

  const isShowCardTitle = useMemo(
    () => <TitleRow key={"-1-0"} {...titleRowProps} />,
    [optionForm]
  );
  //渲染思路，以colData 也就是列数据开始渲染一行行的数据，
  //然后每一行第一列数据就是就是colData里面的description，用于每一行的行头，
  //然后在渲染每一行的数据
  ///////////////////分开 倒叙的业务
  console.log("direction", direction);
  function formatText(arr) {
    if (arr) {
      let result = Object.values(arr).map(item => {
        if (item?.text) {
          return item.text
        }
        return item
      });
      return result
    } else {
      return []
    }
  }
  const dataTotalFn = (type, index, rows, lows, id, id2) => {
    if (type == 2) {
      if (answer[info.id]?.[id]) {
        

        let result = Object.values(answer[info.id]?.[id]);
          result = result.map(ii => {
            if(ii.text){
              return ii.text
            }else{
              return ii
            }
          })
        if (result.includes("true")) {
          return 0 + info?.preferences?.optionPrefer?.optionUnit
        }

        result = result.map(item => {
          if (item?.text) {
            return item.text
          }
          return item
        }).filter(item => (item != "true" && item != "false"))
        ;
        // .filter(item => !isNaN(item));


        let res = result.reduce((acc, current) => acc + Number(current), 0);
        dataTotal[id] = res
        return res + info?.preferences?.optionPrefer?.optionUnit;
      } else {
        dataTotal[id] = 0
        return 0 + info?.preferences?.optionPrefer?.optionUnit
      }
    } else {
      /// 互斥id 
      //  let  findOpen10List =[];
      //  colData.forEach(element => {
      //   let  open10list=element.options.filter(fitem=>fitem.open==10);
      //   findOpen10List.push(...open10list)

      //  });
      //  let  findOpen10ListId =findOpen10List.map(iitem=>iitem.id);

      //  return JSON.stringify(findOpen10ListId)
      if (colData[0].options[index].open == 10) {
        return ""
      }
      let rowLid = [];

      colData.forEach(iitem => {


        rowLid.push(iitem.options[index].id)
      });
      rowLid.pop();
      let rowTotal = [];
      rowLid.forEach(elementId => {
        for (const key in answer[info.id]) {
          if (Object.hasOwnProperty.call(answer[info.id], key)) {
            const element = answer[info.id][key];
            let awsInfo = Object.values(element);
              awsInfo = awsInfo.map(ii => {
                if(ii.text){
                  return ii.text
                }else{
                  return ii
                }})
            let openFlag = awsInfo.includes("true")
            console.log("elementelement", element);
            if (element[elementId] && !openFlag) {
              rowTotal.push(element[elementId])
            }
          }
        }
      });

      rowTotal = rowTotal.map(item => {
        if (item?.text ) {
          return item.text
        }
        return item
      })


      console.log(rowTotal);
      let sum = rowTotal.reduce((acc, current) => acc + Number(current), 0);

      dataTotal[id2] = sum
      return sum + info?.preferences?.optionPrefer?.optionUnit

    }

  }
  const getLastLayerObjects = (obj, result = {}) => {
    if (obj) {
      Object.entries(obj).forEach(([key, value]) => {
        if (typeof value === 'object' && !Array.isArray(value)) {
          if (value?.text) {
            result[key] = value.text;
          } else {
            if (!(formatText(value).includes("true"))) {
              getLastLayerObjects(value, result);
            }
          }
        } else {
          result[key] = value;
          //result.push({ [key]: value });
        }
      });
    }

  };

  function isNaN(v) {
    if (v == NaN) {
      return 0
    }
    return v
  }
  //   行列的计算
  const dataTotalFnAq = (type, id = "", op, colItemData_total, id2, rowItem) => {
    if (type == 1) {

      if (answer[info.id]?.[id]) {
        let result = Object.values(answer[info.id]?.[id]);
        if (formatText(result).includes("true")) {
          return 0 + info?.preferences?.optionPrefer?.optionUnit
        }
        result = result.map(item => {
          if (item?.text) {
            return item.text
          }
          return item
        }).filter(item => (item != "true" && item != "false"));

        let res = result.reduce((acc, current) => {
          return acc + Number(current)
        }, 0)
        dataTotal[id] = res
        return res + info?.preferences?.optionPrefer?.optionUnit
      } else {
        if (id2?.moduleOption == 1) {
          return ''
        }
        dataTotal[id] = 0
        return 0 + info?.preferences?.optionPrefer?.optionUnit
      }
    } else {
      if (op[0].open == 10) {
        return ''
      }
      op.pop()
      let list = op.map(iitem => iitem.id);
      if (colItemData_total) {
        return null
      }

      const lastLayerObjects = {};
      getLastLayerObjects(answer, lastLayerObjects)
      console.log(lastLayerObjects);
      let result = []
      list.forEach(fitem => {
        if (lastLayerObjects[fitem]) {
          result.push(lastLayerObjects[fitem])
        }
      });
      result = result.map(item => {
        if (item?.text) {
          return item.text
        }
        return item
      })

      let res = (result.reduce((acc, value) => acc + Number(value), 0))
      dataTotal[id2] = res
      return res + info?.preferences?.optionPrefer?.optionUnit

    }
  }

  const getAllTotal = () => {
    const lastLayerObjects = {};
    getLastLayerObjects(answer, lastLayerObjects);
    let arr = Object.values(lastLayerObjects);
    arr = arr.filter(item => (item != "true" && item != "false"));
    let result = arr.reduce((acc, value) => acc + Number(value), 0);
    return result + info?.preferences?.optionPrefer?.optionUnit
  }

  const calculateSum = (obj) => {
    let sum = 0;

    for (const key in obj) {
      if (typeof obj[key] === "object") {
        sum += calculateSum(obj[key]);
      } else if (obj[key].text === "1") {
        sum += 1;
      }
    }

    return sum;
  };
  console.log('colDatacolDatacolData', colData);


  if (direction) {
    return (
      <ul className={styles.wrapper}>
        {/**表头数据 */}
        <TitleRow
          key={"-1-0"}
          {...titleRowProps}
          fadeOut={fadeOut}
          questionNum={questionNum}
        />
        {/* ///// */}
        {colData.map((colItem, indexOutter) => {

          let {
            description,
            moduleOption: moduleOptionOutter,
            open: openOutter,
            hide,
          } = colItem;

          if (hide) return null;

          return (
            <Fragment key={indexOutter}>
              {/**通过headLineShow 控制要隔多少行在渲染一列表头 */}
              {headLineShow > 0 &&
                !!indexOutter &&
                indexOutter % headLineShow === 0 && (
                  <TitleRow
                    key={`-1-${indexOutter}`}
                    {...titleRowProps}
                    fadeOut={fadeOut}
                    questionNum={questionNum}
                  />
                )}
              <li
                key={indexOutter}
                style={{
                  // border: "none",
                  // borderLeft: ".5px solid #b2c2cc",
                  // borderRight: ".5px solid #b2c2cc",
                  // borderBottom: ".5px solid #b2c2cc",
                  // padding: -1,
                }}
              >
                {/**模块题头的样式 */}
                {+moduleOptionOutter > 0 ? (
                  <div
                    key={-1}
                    style={firstStyle}
                    className="disabled add_flags"
                    dangerouslySetInnerHTML={{
                      __html: description
                        .replace(/<p><\/p>/g, "<br />")
                        .replace(/\n\n/g, "<br />")
                        .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                    }}
                  />
                ) : (
                  <div
                    key={-1}
                    className=""
                    style={{ ...firstStyle, display: 'flex' }}
                    dangerouslySetInnerHTML={{
                      __html: description
                        .replace(/<p><\/p>/g, "<br />")
                        .replace(/\n\n/g, "<br />")
                        .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                    }}
                  />
                )}
                {/**渲染每一列  rowData*/}
                {colItem.options_1.map((rowItem, indexInner) => {
                  if (colItem.data_total == 1) {
                    rowItem.moduleOption = 0
                  }
                  if (fadeOut == 1 && indexInner >= questionNum) {
                    return null;
                  }
                  // 隐藏模块不显示
                  if (+rowItem.moduleOption === 2) {
                    return null;
                  }
                  const {
                    moduleOption,
                    id: idInner,
                    open: openInner,
                  } = rowItem;

                  // 受控组件获取value 其实就是通过行列 对应带每一个单元格能确定一个数据
                  // 题目的id，optionId，在加上渲染的数组下标值，就能从answer中找到位移对应的值
                  // 通过Q/A 还是 A/Q 就要反转一下，打印一些数据就会明白了
                  let value;
                  if (type === "input") {
                    value = get(
                      answer,
                      `[${id}][${rowItem.options_3.id}][${rowItem.id}]`,
                      ""
                    );

                    if (value?.text) {
                      value = value.text;
                    }
                    if (typeof value == 'object') {
                      value = value.text;
                    }

                  } else if (type === "radio") {
                    value =
                      get(
                        answer,
                        `[${id}][${rowItem.options_3.id}][${rowItem.id}]`,
                        false
                      ) !== false;
                  } else if (type === "checkbox") {
                    value =
                      get(
                        answer,
                        `[${id}][${rowItem.options_3.id}][${rowItem.id}]`,
                        false
                      ) !== false;
                  } else {
                    value =
                      get(
                        answer,
                        `[${id}][${rowItem.options_3.id}][${rowItem.id}]`,
                        false
                      ) !== false;
                  }
                  return (
                    <div
                      key={indexInner}
                      style={leaveStyle}
                      className={classNames(styles.spanItem, {
                        disabled:
                          +rowItem.moduleOption !== 0 ||
                          rowItem.options_3.moduleOption !== 0,
                      })}
                    >

                      {/**模块题 的样式  所有的选项都要通过direction的值判断要取哪里的值 主要就是要能查到对应option的位置获取到option中的各个属性*/}
                      {+moduleOptionOutter || +moduleOption ? (
                        <ModuleDom tag="p" moduleOption={moduleOption} style={{background: "#e5e5e5"}} />
                      ) : (
                        {
                          radio: (
                            <div
                              className={styles.openContainer}
                              style={{ width: "100%" }}
                              onClick={(e) => {
                                // debugger
                                if (rowItem.disable) return;
                                if (rowItem.fixed) return;
                                //值改变的时候要去修改对应的答案值，因为是受控组件 核心思路还是要用之前的去的id optionid index数据来拿到真正改变的值
                                // 同时还是要通过direction来判断，下同
                                if (
                                  indexInner + 1 === questionNum &&
                                  colItem.options_1.length !== questionNum
                                ) {
                                  // 逐渐显示
                                  const nextItem =
                                    colItem.options_1?.[indexInner + 1] || {};
                                  if (
                                    nextItem.options_3.moduleOption ||
                                    nextItem.options_3.hide
                                  ) {
                                    setQuestionNum(questionNum + 2);
                                  } else {
                                    setQuestionNum(questionNum + 1);
                                  }
                                }
                                let obj = {}; //映射下面的写法   可以替换暂时不修改以前
                                obj[rowItem.options_3.id] = {
                                  [rowItem.id]: null,
                                };
                                const newAnswer = {
                                  ...answer[id],
                                  ...obj,
                                };

                                if (limit) {
                                  // 行列均单选
                                  for (const [
                                    childQuestionId,
                                    subAnswer = {},
                                  ] of Object.entries(newAnswer)) {
                                    const [optionId] = Object.keys(subAnswer);
                                    if (
                                      (rowItem.sameLine || []).includes(
                                        optionId
                                      )
                                    ) {
                                      delete newAnswer[childQuestionId];
                                    }
                                  }
                                }
                                dispatch({
                                  type: "highlight",
                                  data: { highlight: "" },
                                });
                                changeAnswer(newAnswer);
                              }}
                            >
                              {+rowItem.hide ||
                                rowItem.options_3.moduleOption !== 0 ? null : (
                                <>
                                  <Radio
                                    checked={value}
                                    disabled={rowItem.fixed || rowItem.disable}
                                  />
                                  {/**是否为半开题 下同 */}
                                  {(+openInner > 0 || +openOutter > 0) &&
                                    value && (
                                      <InputWapper unit={rowItem.unit}>
                                        <Input
                                          placeholder={language().input_placeholder}
                                          defaultValue={get(
                                            answer,
                                            `[${id}][${rowItem.options_3.id}][${rowItem.id}]["text"]`,
                                            ""
                                          )}
                                          onChange={(e) => {
                                            if(!e.target.value){
                                              delete answer[id][rowItem.options_3.id][rowItem.id]
                                              changeAnswer({
                                                ...answer[id],
                                                ...obj,
                                              });
                                              return 
                                            }

                                            let obj = {}; //映射下面的写法   可以替换暂时不修改以前
                                            obj[rowItem.options_3.id] = {
                                              [rowItem.id]: e.target.value,
                                            };
                                            changeAnswer({
                                              ...answer[id],
                                              ...obj,
                                            });
                                          }}
                                        />
                                      </InputWapper>
                                    )}
                                </>
                              )}
                            </div>
                          ),
                          checkbox: (
                            <span className={styles.openContainer}>
                              {+rowItem.hide === 1 ? null : (
                                <>
                                  <Checkbox
                                    checked={value}
                                    disabled={
                                      +direction === 0
                                      // ? +optionsOutter[indexInner].fixed === 1
                                      // : +optionsInner[indexOutter].fixed === 1
                                    }
                                    onChange={(e) => {
                                      let obj = {}; //映射下面的写法   可以替换暂时不修改以前
                                      if (e.target.checked) {
                                        obj[rowItem.options_3.id] = {
                                          [rowItem.id]: null,
                                        };
                                      } else {
                                        delete answer[id][rowItem.options_3.id][
                                          rowItem.id
                                        ];
                                        if (
                                          Object.keys(
                                            answer[id][rowItem.options_3.id]
                                          ).length === 0
                                        ) {
                                          delete answer[id][
                                            rowItem.options_3.id
                                          ];
                                        }
                                      }

                                      let dObj = { ...answer[id] };
                                      let cObj = deepMerge(dObj, obj);
                                      changeAnswer(cObj);
                                    }}
                                  />
                                  {(+openInner > 0 || +openOutter > 0) &&
                                    value && (
                                      <InputWapper unit={rowItem.unit}>
                                        <Input
                                          placeholder={language().input_placeholder}
                                          onChange={(e) => {

                                            if(!e.target.value){
                                               
                                              delete answer[id][rowItem.options_3.id][rowItem.id]
                                              changeAnswer({
                                                ...answer[id],
                                                ...obj,
                                              });
                                              return 
                                            }
                                            let obj = {}; //映射下面的写法   可以替换暂时不修改以前
                                            obj[rowItem.options_3.id] = {
                                              [rowItem.id]: e.target.value,
                                            };
                                            changeAnswer({
                                              ...answer[id],
                                              ...obj,
                                            });
                                          }}
                                        />
                                      </InputWapper>
                                    )}
                                </>
                              )}
                            </span>
                          ),
                          input: (
                            <>
                              {(colItem.data_total || rowItem.options_3.data_total) ?
                                <>
                                  {(colItem.data_total && rowItem.options_3.data_total) ? <>{getAllTotal()}</>
                                    :
                                    <div>
                                      {colItem.data_total && dataTotalFnAq("1", rowItem.options_3.id, null, null, rowItem.options_3)}

                                      {rowItem.options_3.data_total && dataTotalFnAq("2", null, colItem.options_1, colItem.data_total, colItem.options_1[indexInner].id)}

                                    </div>
                                  }

                                </>
                                : <>
                                  {rowItem.hide === 1 ||
                                    rowItem.options_3.moduleOption === 1 ? null : (
                                    rowItem.open == 10
                                      ? <>
                                        <Checkbox checked={value == "true" ? true : false} onChange={(e) => {
                                          let input_obj = {};
                                          input_obj[rowItem.options_3.id] = {
                                            [rowItem.id]: e.target.checked + "",
                                          };
                                          const newAnswer = get(
                                            answer,
                                            `[${id}][${idInner}]`,
                                            {}
                                          );
                                          newAnswer[rowItem.options_3.id] = {
                                            [rowItem.id]: e.target.checked + "",
                                          };

                                          if (!e.target.checked) {
                                            delete answer[id][rowItem.options_3.id][rowItem.id]
                                            dispatch({
                                              type: "highlight",
                                              data: { highlight: "" },
                                            });
                                            changeAnswer(
                                              { ...answer[id] }
                                            );
                                            return
                                          }


                                          changeAnswer(
                                            deepMerge({ ...answer[id] }, { ...newAnswer })
                                          );
                                        }}> </Checkbox>
                                      </> :
                                      <InputWapper unit={rowItem.unit}>
                                        <Input
                                          placeholder={language().input_placeholder}
                                          value={value}
                                          disabled={isDisabled(get(
                                            answer,
                                            `[${id}][${rowItem.options_3.id}]`,
                                            {}
                                          ), rowItem.options_3.options , rowItem.options_3.id)}
                                          onChange={(e) => {
                                            if(!e.target.value){
                                              delete answer[id][rowItem.options_3.id][rowItem.id]
                                              changeAnswer({
                                                ...answer[id],
                                              });
                                              return 
                                            }

                                            let input_obj = {};
                                            input_obj[rowItem.options_3.id] = {
                                              [rowItem.id]: e.target.value,
                                            };
                                            const newAnswer = get(
                                              answer,
                                              `[${id}][${idInner}]`,
                                              {}
                                            );
                                            newAnswer[rowItem.options_3.id] = {
                                              [rowItem.id]: e.target.value,
                                            };

                                            dispatch({
                                              type: "highlight",
                                              data: { highlight: "" },
                                            });

                                            changeAnswer(
                                              deepMerge({ ...answer[id] }, newAnswer)
                                            );
                                          }}
                                        />
                                      </InputWapper>
                                  )}

                                </>}


                            </>
                          ),
                        }[type]
                      )}
                    </div>
                  );
                })}
              </li>
            </Fragment>
          );
        })}
      </ul>
    );
  } else {
    ////////////////////倒序的，分开梳理业务 options
    let questions = colData;
    if (fadeOut == 1) {
      if (questions[0]?.moduleOption === 1 && questionNum == 1) {
        setQuestionNum(2);
      }
      questions = colData.slice(0, questionNum);
    }
    // 下面这一行会造成数据显示不完整的问题 【1000118】
    // 多对
    // questions = deleteItem(questions);

    // 检查卡片题是否能用于当前客户端
    let cardOptionFormEnable = false;
    if (optionForm === 4) {
      const pcH5SettingValue = pcH5Setting ?? 0;
      cardOptionFormEnable = true;
      if (pcH5SettingValue === 1 && isMobile) {
        cardOptionFormEnable = false;
      }
      if (pcH5SettingValue === 2 && !isMobile) {
        cardOptionFormEnable = false;
      }
    }
    
    return (
      <ul className={styles.wrapper}>
        {/**表头数据 */}
        {!cardOptionFormEnable && isShowCardTitle}
        <CarouselComponent
          colData={colData}
          info={info}
          callback={(dom, autoplayFn) => {
            setcarouseFn({ ...dom, autoplayFn });
          }}
        >
          {questions.map((colItem, indexOutter) => {

            let {
              description,
              moduleOption: moduleOptionOutter,
              id: idOutter,
              open: openOutter,
            } = colItem;
            if (description === null) {
              description = "";
            }
            //  || colItem.hide === 1
            if (+moduleOptionOutter === 2) {
              return null;
            }
            return (
              <Fragment key={indexOutter}>
                {/* 设置卡片的显示方式 */}
                {cardOptionFormEnable && isShowCardTitle}
                {/**通过headLineShow 控制要隔多少行在渲染一列表头 */}
                {headLineShow > 0 &&
                  !!indexOutter &&
                  indexOutter % headLineShow === 0 && (
                    <TitleRow key={`-1-${indexOutter}`} {...titleRowProps} />
                  )}
                {headLineShow == -1 && moduleOptionOutter == 1 && (<TitleRow key={`-1-${indexOutter}`} {...titleRowProps} />)}
                <li key={indexOutter}>
                  {/**模块题头的样式 */}
                  {+moduleOptionOutter > 0 ? (
                    <div
                      key={-1}
                      style={firstStyle}
                      className="disabled add_flags"
                      dangerouslySetInnerHTML={{
                        __html: description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                      }}
                    />
                  ) : (
                    <AnswerValidityChren
                      info={colItem}
                      answer={{}}
                      changeAnswer={{}}
                      style={firstStyle}
                    >
                      <div
                        key={-1}
                        className=""
                        // style={firstStyle}


                        dangerouslySetInnerHTML={{
                          __html: description
                            .replace(/<p><\/p>/g, "<br />")
                            .replace(/\n\n/g, "<br />")
                            .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                        }}
                      />
                    </AnswerValidityChren>
                  )}
                  {/**渲染每一列  rowData*/}
                  {colItem.options.map((rowItem, indexInner) => {
                    const { moduleOption, open: openInner } = rowItem;
                    // 隐藏模块不显示  || +rowItem.hide === 1
                    if (+rowItem.moduleOption === 2) {
                      return null;
                    }

                    // 受控组件获取value 其实就是通过行列 对应带每一个单元格能确定一个数据
                    // 题目的id，optionId，在加上渲染的数组下标值，就能从answer中找到位移对应的值
                    // 通过Q/A 还是 A/Q 就要反转一下，打印一些数据就会明白了
                    let value;
                    let disabled = false;
                    if (type === "input") {
                      // prettier-ignore
                      value = get(answer, `["${id}"]["${idOutter}"]["${rowItem.id}"]`, "");
                      if (isObject(value)) value = value.text;
                    } else if (type === "checkbox") {
                      // prettier-ignore
                      value = get(answer, `[${id}][${idOutter}][${rowItem.id}]`, false) !== false;
                    } else {
                      // prettier-ignore
                      value = get(answer, `[${id}][${idOutter}][${rowItem.id}]`, false) !== false;
                      // 默认选中啥的 radio
                      // 这里不能加设置答案，容易死循环
                      if (rowItem.selected) {
                        value = true;
                      }
                      if (rowItem.fixed || rowItem.disable) {
                        disabled = true;
                      }
                    }
                    return (
                      <div
                        key={indexInner}
                        style={leaveStyle}
                        className={classNames(styles.spanItem, {
                          disabled:
                            +moduleOptionOutter !== 0 || +moduleOption !== 0,
                        })}
                      >
                        {/**模块题 的样式  所有的选项都要通过direction的值判断要取哪里的值 主要就是要能查到对应option的位置获取到option中的各个属性*/}
                        {+moduleOptionOutter || +moduleOption ? (
                          <ModuleDom tag="p" moduleOption={moduleOption} style={{background: "#e5e5e5"}} />
                        ) : (
                          {
                            radio: (
                              <AnswerValidityChrenClick
                                colItem={colItem}
                                className={styles.openContainer}
                                style={{ width: "100%" }}
                                onClick={(e) => {
                                  if (disabled) {
                                    return;
                                  }
                                  if (carouseFn) {
                                    carouseFn.autoplayFn();
                                  }
                                  //值改变的时候要去修改对应的答案值，因为是受控组件 核心思路还是要用之前的去的id optionid index数据来拿到真正改变的值
                                  // 同时还是要通过direction来判断，下同
                                  if (indexOutter + 1 === questionNum) {
                                    // 逐渐显示
                                    const nextItem =
                                      colData?.[indexOutter + 1] || {};
                                    if (
                                      nextItem.moduleOption ||
                                      nextItem.hide
                                    ) {
                                      setQuestionNum(questionNum + 2);
                                    } else {
                                      setQuestionNum(questionNum + 1);
                                    }
                                  }
                                  let obj = {}; //映射下面的写法   可以替换暂时不修改以前
                                  obj[colItem.id] = {
                                    [rowItem.id]: null,
                                  };
                                  const newAnswer = {
                                    ...answer[id],
                                    [colItem.id]: {
                                      [rowItem.id]: null,
                                    },
                                  };
                                  if (limit) {
                                    // 行列均单选
                                    for (const [
                                      childQuestionId,
                                      subAnswer = {},
                                    ] of Object.entries(newAnswer)) {
                                      const [optionId] = Object.keys(subAnswer);
                                      if (
                                        (rowItem.sameLine || []).includes(
                                          optionId
                                        )
                                      ) {
                                        delete newAnswer[childQuestionId];
                                      }
                                    }
                                  }
                                  changeAnswer(newAnswer);
                                }}
                              >
                                {+rowItem.hide ? null : (
                                  <>
                                    {/* 展示格子的对应ID*/}
                                    {/* {rowItem.id === [optionsOutter[indexInner].id]} */}
                                    <Radio
                                      checked={value}
                                      disabled={disabled}
                                    />
                                    {/**是否为半开题 下同 */}
                                    {(+openInner > 0 || +openOutter > 0) &&
                                      value && (
                                        <InputWapper unit={rowItem.unit}>
                                          <Input
                                            placeholder={language().input_placeholder}
                                            defaultValue={get(
                                              answer,
                                              `[${id}][${idOutter}][${rowItem.id}]["text"]`,
                                              ""
                                            )}
                                            onChange={(e) => {
                                              e.stopPropagation();
                                              changeAnswer({
                                                ...answer[id],
                                                [idOutter]: {
                                                  [rowItem.id]: e.target.value,
                                                },
                                              });
                                            }}
                                          />
                                        </InputWapper>
                                      )}
                                  </>
                                )}
                              </AnswerValidityChrenClick>
                            ),
                            checkbox: (
                              <span className={styles.openContainer}>
                                {+rowItem.hide === 1 ? null : (
                                  <>
                                    <Checkbox
                                      checked={value}
                                      disabled={
                                        +rowItem.fixed === 1 || rowItem.disable
                                      }
                                      onChange={(e) => {
                                        const newAnswer = get(
                                          answer,
                                          `[${id}][${idOutter}]`,
                                          {}
                                        );
                                        if (e.target.checked) {
                                          newAnswer[rowItem.id] = null;
                                          changeAnswer({
                                            ...answer[id],
                                            [idOutter]: newAnswer,
                                          });
                                        } else {
                                          delete answer[id][idOutter];
                                          changeAnswer({
                                            ...answer[id],
                                          });
                                        }
                                      }}
                                    />
                                    {(+openInner > 0 || +openOutter > 0) &&
                                      value && (
                                        <InputWapper unit={rowItem.unit}>
                                          <Input
                                            placeholder={language().input_placeholder}
                                            defaultValue={get(
                                              answer,
                                              `[${id}][${idOutter}][${rowItem.id}]['text']`,
                                              ""
                                            )}
                                            onChange={(e) => {
                                              const newAnswer = get(
                                                answer,
                                                `[${id}][${idOutter}]`,
                                                {}
                                              );
                                              newAnswer[rowItem.id] =
                                                e.target.value;
                                              changeAnswer({
                                                ...answer[id],
                                                [idOutter]: newAnswer,
                                              });
                                            }}
                                          />
                                        </InputWapper>
                                      )}
                                  </>
                                )}
                              </span>
                            ),
                            input: (
                              <>
                                {/* {colItem.id}  */}
                                {colItem.data_total || rowItem.data_total ?
                                  <>
                                    <>
                                      {(colItem.data_total && rowItem.data_total) ? <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%"
                                      }}> {getAllTotal()}</div> :
                                        <div style={{
                                          display: "flex",
                                          alignItems: "center",
                                          height: "100%"
                                        }}>
                                          {colItem.data_total && dataTotalFn(1, indexInner, colItem.data_total, rowItem.data_total, colItem.id, rowItem.id)}
                                          {rowItem.data_total && dataTotalFn(2, indexInner, colItem.data_total, rowItem.data_total, colItem.id)}


                                        </div>
                                      }

                                    </>
                                  </>
                                  || "" :
                                  <>
                                    {+rowItem.hide === 1 ? null : (
                                      rowItem.open == 10 ? <div>

                                        {/* {answer?.[id]?.[idOutter]?.[rowItem.id]} */}
                                        <Checkbox checked={value == "true" ? true : false} onChange={(e) => {
                                          if (!e.target.checked) {
                                            delete answer[id][idOutter][rowItem.id]
                                            changeAnswer({...answer[id]});
                                          } else {
                                            changeAnswer({
                                              ...answer[id],
                                              [idOutter]: {
                                                ...get(
                                                  answer,
                                                  `[${id}][${idOutter}]`,
                                                  {}
                                                ),
                                                [rowItem.id]: e.target.checked + "",
                                              },
                                            });
                                          }
                                          return
                                        }}></Checkbox>
                                      </div> :
                                        <InputWapper unit={rowItem.unit}>
                                           <AnswerValidityChrenClick
                                            colItem={colItem}
                                            value={value}
                                            disabled={
                                              (+rowItem.fixed === 1 || rowItem.disable) || isDisabled(answer?.[id]?.[idOutter], colItem.options)
                                            }
                                            onChange={(e) => {

                                              if(!e.target.value){
                                               
                                                delete answer[id][idOutter][rowItem.id]
                                                changeAnswer({
                                                  ...answer[id],
                                                });
                                                return 
                                              }
                                               
                                              changeAnswer({
                                                ...answer[id],
                                                [idOutter]: {
                                                  ...get(
                                                    answer,
                                                    `[${id}][${idOutter}]`,
                                                    {}
                                                  ),
                                                  [rowItem.id]: e.target.value,
                                                },
                                              });
                                            }}
                                          />
                                        </InputWapper>
                                    )}
                                  </>

                                } </>

                            ),
                          }[type]
                        )}
                      </div>
                    );
                  })}
                </li>
                {headLineShow == -2 && moduleOptionOutter == 1 && (<TitleRow key={`-1-${indexOutter}`} {...titleRowProps} />)}
              </Fragment>
            );
          })}
        </CarouselComponent>
      </ul>
    );
  }
};
function isDisabled(obj, opt) {
  
  if (obj) {
    for (let index = 0; index < opt.length; index++) {
      const element = opt[index];
      if (element.open == 10&&obj[element.id] ) {
        if (obj[element.id]?.text) {
          return obj[element.id]?.text == "true" ? true : false
        } else {
          return obj[element.id] == "true" ? true : false
        }
      }
    }
  }
  return false
}


function checkboxVal(p1, p2) {
  debugger
}
export default Matrix;
